import React from "react";

function Login() {
    return (
        <div>email!</div>
    );
}

export default Login;